import ComposerTextboxWithTokens from './ComposerTextboxWithTokens';

export default ComposerTextboxWithTokens;
